import React, { useEffect, useState } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import PersonaBadge from '../../common/PersonaBadge';
import api from '../../../services/api';

interface Props {
  workflowId: string;
}

const ArtifactOutput: React.FC<Props> = ({ workflowId }) => {
  const { darkMode } = useTheme();
  const [links, setLinks] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get all cross-system links that reference this workflow
    api.get(`/analytics/cross-system/activity-feed?limit=200`)
      .then(r => {
        const events = r.data?.events || [];
        // Filter for artifact generation events
        setLinks(events.filter((e: any) =>
          e.event_type === 'generated_by' && e.metadata?.workflow_id === workflowId
        ));
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [workflowId]);

  if (loading) return <div className={`text-sm ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>Loading artifacts...</div>;

  if (links.length === 0) {
    return (
      <div className={`p-8 text-center rounded-xl border ${darkMode ? 'border-gray-700 text-gray-500' : 'border-gray-200 text-gray-400'}`}>
        No artifacts produced by this workflow yet. Artifacts appear here when workflow phases generate code via the artifactory.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
      {links.map((link, i) => (
        <div
          key={link.id || i}
          className={`p-4 rounded-xl border transition-all hover:scale-[1.01] ${
            darkMode ? 'bg-gray-800/60 border-gray-700 hover:border-cyan-600/50' : 'bg-white border-gray-200 hover:border-cyan-400'
          }`}
        >
          <p className={`text-sm font-medium truncate ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>
            {link.metadata?.node_path || 'Artifact'}
          </p>
          <div className="flex items-center gap-2 mt-2">
            {link.persona_name && (
              <PersonaBadge personaId={link.persona_id || ''} personaName={link.persona_name} size="xs" clickable={false} />
            )}
            <span className={`text-xs ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
              {new Date(link.timestamp).toLocaleDateString()}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ArtifactOutput;
